import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e035f820&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StudentInformatie: require('/data/www/nvpa.org/nvpa/nuxt/components/student/Informatie.vue').default,StudentForm: require('/data/www/nvpa.org/nvpa/nuxt/components/student/form.vue').default,StudentError: require('/data/www/nvpa.org/nvpa/nuxt/components/student/error.vue').default,StudentSuccess: require('/data/www/nvpa.org/nvpa/nuxt/components/student/success.vue').default})
